import React, { useMemo } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  SimpleGrid,
  Box,
  Input,
  FormLabel,
  Select,
  InputGroup,
  InputLeftAddon,
  useDisclosure,
  Checkbox,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import toast from "react-hot-toast";
import { set } from "lodash";
import Cookie from "js-cookie";

const EditQuickBillModal = ({
  isOpen,
  onClose,
  id,
  customerId,
  onOpen,
  setSelectId,
  data,
}) => {
  console.log(id, "id");
  const token = Cookie.get("token");
  const [selectedFile, setSelectedFile] = useState(null);
  const [serverName, setServerName] = useState([]);
  const [newImageURL, setnewImageURL] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({
    foodItem: [],
    wineItem: [],

    name: "",
    phoneNo: "",
    billNo: "",
    tableNo: "",
    server: "",
    totalBilling: 0,
    discount: 0,
    discountPercentage: 0,
    cash: 0,
    mode: "",
    online: 0,
    createdAt: "",
    tax: 0,
  });

  console.log(Object.keys(data) + " :" + Object.values(data), "data");
  const serverData = async () => {
    try {
      const response = await axios.get(
        `https://api.rcb.tdrsoftware.in/api/waiterList/${customerId}`
      );
      setServerName(response.data.waiterList);
    } catch (error) {}
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // Extracts the YYYY-MM-DD part
  };

  useEffect(() => {
    serverData();
  }, [customerId]);
  useEffect(() => {
    if (data) {
      //const date = new Date(data.createdAt).toLocaleString();
      setFormData({
        foodItem: data.foodItem || [],
        wineItem: data.wineItem || [],
        name: data.name || "",
        phoneNo: data.phoneNo || "",
        billNo: data.billNo || "",
        tableNo: data.tableNo || "",
        server: data.server || "",
        totalBilling: data.totalBilling || 0,
        discount: data.discount || 0,
        discountPercentage: data.discountPercentage || 0,
        cash: data.cash || 0,
        mode: data.mode || "",
        online: data.online || 0,
        due: data.due || 0,
        createdAt: data.createdAt ? formatDate(data.createdAt) : "",
        tax: Math.round(data.cgst + data.sgst) || 0,
      });
    }
  }, [data]);
  const scroll = "inside";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  useEffect(() => {
    setFormData({
      ...formData,
      totalBilling: data.totalBilling,
    });
  }, [
    formData.foodItem,
    formData.wineItem,
    formData.discount,
    formData.discountPercentage,
  ]);
  //   useEffect(() => {

  //   const totalPaid =
  //     (formData.cash ? parseInt(formData.cash) : 0) +
  //     (formData.online ? parseInt(formData.online) : 0) +
  //     (formData.discount ? parseInt(formData.discount) : 0) +
  //     ((formData.discountPercentage / 100) * totalBilling);

  //   const newDue = Math.max(totalBilling - totalPaid, 0); // Prevent negative due
  //   setFormData((prev) => ({
  //     ...prev,
  //     due: newDue,
  //   }));
  // }, [formData.cash, formData.online, formData.discount, formData.discountPercentage, totalBilling]);

  const computeItemGstAmt = (item) => {
    const qty = Number(item.quantity) || 0;
    const price = Number(item.price) || 0;
    const totalRate = (Number(item.sgst) || 0) + (Number(item.cgst) || 0); // percentages
    return Number(((price * qty * totalRate) / 100).toFixed(2));
  };

  /////////////////////////////////////////////////////////////////////////////////
  const handleFoodItemChange = (index, field, value) => {
    setFormData((prev) => {
      const food = [...prev.foodItem];
      const oldItem = food[index];

      const unitPrice =
        oldItem.unitPrice ||
        Number(oldItem.price) / (Number(oldItem.quantity) || 1) ||
        0;

      const updatedItem = { ...oldItem, [field]: value };
      const newQty = Number(updatedItem.quantity) || 0;

      if (field === "quantity") {
        updatedItem.price = unitPrice * newQty;
        updatedItem.unitPrice = unitPrice;
      }

      if (field === "price") {
        updatedItem.price = Number(value) || 0;
        updatedItem.unitPrice =
          updatedItem.quantity > 0
            ? updatedItem.price / updatedItem.quantity
            : updatedItem.price;
      }

      food[index] = updatedItem;

      // Recalc total billing only (no gstAmt)
      const totalBilling =
        food.reduce((sum, item) => sum + (Number(item.price) || 0), 0) +
        prev.wineItem.reduce((sum, item) => sum + (Number(item.price) || 0), 0);

      return {
        ...prev,
        foodItem: food,
        totalBilling,
      };
    });
  };

  const handleWineItemChange = (index, field, value) => {
    setFormData((prev) => {
      const wine = [...prev.wineItem];
      const oldItem = wine[index];

      const unitPrice =
        oldItem.unitPrice ||
        Number(oldItem.price) / (Number(oldItem.quantity) || 1) ||
        0;

      const updatedItem = { ...oldItem, [field]: value };
      const newQty = Number(updatedItem.quantity) || 0;

      if (field === "quantity") {
        updatedItem.price = unitPrice * newQty;
        updatedItem.unitPrice = unitPrice;
      }

      if (field === "price") {
        updatedItem.price = Number(value) || 0;
        updatedItem.unitPrice =
          updatedItem.quantity > 0
            ? updatedItem.price / updatedItem.quantity
            : updatedItem.price;
      }

      wine[index] = updatedItem;

      const totalBilling =
        prev.foodItem.reduce(
          (sum, item) => sum + (Number(item.price) || 0),
          0
        ) + wine.reduce((sum, item) => sum + (Number(item.price) || 0), 0);

      return {
        ...prev,
        wineItem: wine,
        totalBilling,
      };
    });
  };

  // -------------------- GST Calculator --------------------
  const calculateTotalGST = (foodItems, wineItems) => {
    return [...foodItems, ...wineItems]
      .reduce((total, item) => total + (parseFloat(item.gstAmt) || 0), 0)
      .toFixed(2);
  };

  // -------------------- Billing Totals --------------------
  const totalfoodBiiling = useMemo(() => {
    return formData.foodItem?.reduce((total, item) => {
      return total + (parseFloat(item.price) || 0);
    }, 0);
  }, [formData.foodItem]);

  const totalwineBiiling = formData.wineItem?.reduce((total, item) => {
    return total + (parseFloat(item.price) || 0);
  }, 0);

  const totalBilling = totalfoodBiiling + totalwineBiiling;

  const cashDiscount = Math.round(
    totalBilling +
      data.cgst +
      data.sgst -
      formData.discount -
      (formData.discountPercentage / 100) * totalBilling
  );

  // -------------------- Cash Calculation --------------------
  useEffect(() => {
    const grossBilling = totalBilling || 0;

    const discountPerc = parseFloat(formData.discountPercentage) || 0;
    const discountFlat = parseFloat(formData.discount) || 0;

    // 🍽️ Separate food & wine totals before discount
    const foodTotal = formData.foodItem.reduce(
      (sum, item) => sum + (Number(item.price) || 0),
      0
    );
    const wineTotal = formData.wineItem.reduce(
      (sum, item) => sum + (Number(item.price) || 0),
      0
    );

    // Apply discount proportionally on food + wine
    const grossTotalBeforeDiscount = foodTotal + wineTotal;
    let discountedFood = foodTotal;
    let discountedWine = wineTotal;

    if (grossTotalBeforeDiscount > 0) {
      const totalDiscount =
        (discountPerc / 100) * grossTotalBeforeDiscount + discountFlat;

      // distribute discount proportionally
      const foodShare = foodTotal / grossTotalBeforeDiscount;
      const wineShare = wineTotal / grossTotalBeforeDiscount;

      discountedFood -= totalDiscount * foodShare;
      discountedWine -= totalDiscount * wineShare;
    }

    // ✅ GST only on food (after discount)
    const gst = Math.max(discountedFood, 0) * 0.05;

    // Final total (food + wine after discount + GST on food only)
    const totalWithGST =
      Math.max(discountedFood, 0) + Math.max(discountedWine, 0) + gst;

    const remainingCash = Math.ceil(
      totalWithGST - (parseFloat(formData.online) || 0)
    );

    setFormData((prev) => ({
      ...prev,
      cash: remainingCash,
      totalBilling: totalWithGST, // now final billing includes GST
      tax: gst, // 👈 GST only on food
    }));
  }, [
    totalBilling,
    formData.online,
    formData.discount,
    formData.discountPercentage,
    formData.foodItem,
    formData.wineItem,
  ]);

  // const handleWineItemChange = (index, field, value) => {
  //   const updatedWineItems = formData.wineItem.map((item, i) =>
  //     i === index ? { ...item, [field]: value } : item
  //   );
  //   setFormData({ ...formData, wineItem: updatedWineItems });
  // };

  const handleDeleteItem = (type, index) => {
    if (type === "food") {
      const updatedFoodItems = formData.foodItem.filter((_, i) => i !== index);
      toast.success("Food item deleted successfully");
      setFormData({ ...formData, foodItem: updatedFoodItems });
    } else if (type === "wine") {
      const updatedWineItems = formData.wineItem.filter((_, i) => i !== index);
      toast.success("Wine item deleted successfully");
      setFormData({ ...formData, wineItem: updatedWineItems });
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    let totalPayment =
      parseInt(formData.cash) +
      parseInt(formData.online) +
      parseInt(formData.discount);

    // if ((totalPayment + formData.due) > (formData.totalBilling)) {
    //   toast.error('Cash and Online amount should not be greater than total billing');
    //   return;
    // }
    // else if ((totalPayment + formData.due) < (formData.totalBilling)) {
    //   toast.error('Cash and Online amount should not be less than total billing');
    //   return;
    // }

    try {
      // Make the PUT request with formData directly
      const response = await axios.put(
        `https://api.rcb.tdrsoftware.in/api/quickBillUpdate/${customerId}/${id}?customerId=${customerId}`,
        { data: formData },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(response.data.message);
      console.log(response, "response");
      //setSelectId(null);
      // Optionally reset the form after a successful update
      setFormData({
        foodItem: [],
        wineItem: [],

        name: "",
        phoneNo: "",
        billNo: "",
        tableNo: "",
        server: "",
        totalBilling: 0,
        discount: 0,
        discountPercentage: 0,
        cash: 0,
        mode: "",
        online: 0,
        due: 0,
        createdAt: "",
      });

      window.location.reload();
    } catch (error) {
      if (error.response && error.response.status === 403) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while updating the data");
      }
    }
  };
  const handleClick = () => {
    onClose();
    setSelectId(null);
  };
  return (
    <Modal
      width="full"
      size="5xl"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      scrollBehavior={scroll}
    >
      <ModalOverlay />
      <ModalContent bg="#f9f1e3">
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text>Bill Data- {data?.name}</Text>
          <Button colorScheme="red" onClick={handleClick}>
            <IoMdClose />
          </Button>
        </ModalHeader>

        <ModalBody>
          <Box textAlign="center">
            {formData.foodItem.length > 0 ? (
              <Text fontSize="20px" fontWeight="bold">
                Food Items
              </Text>
            ) : (
              ""
            )}
            {formData.foodItem?.map((item, index) => (
              <Box
                key={index}
                bg="white"
                p={4}
                borderRadius="md"
                display="flex"
                boxShadow="md"
                width="100%"
                mb={1}
                justifyContent="space-evenly"
                alignItems="center"
              >
                <FormLabel>Name</FormLabel>
                <Input width="35%" bg="#E2DFE0" value={item.name} readOnly />
                <FormLabel>HsnNo</FormLabel>
                <Input width="35%" bg="#E2DFE0" value={item.hsnNo} readOnly />
                <FormLabel>GstAmt</FormLabel>
                <Input
                  width="35%"
                  bg="#E2DFE0"
                  value={
                    (parseFloat(item.sgst) || 0) + (parseFloat(item.cgst) || 0)
                  }
                  readOnly
                />
                {/* <FormLabel>Quantity</FormLabel> */}
                <FormLabel>Qty</FormLabel>
                <Input
                  width="10%"
                  bg="white"
                  value={item.quantity}
                  onChange={(e) =>
                    handleFoodItemChange(index, "quantity", e.target.value)
                  }
                />
                <FormLabel>Price</FormLabel>
                <Input
                  width="12%"
                  bg="white"
                  value={item.price}
                  onChange={(e) =>
                    handleFoodItemChange(index, "price", e.target.value)
                  }
                />
                <Button
                  colorScheme="red"
                  onClick={() => handleDeleteItem("food", index)}
                >
                  Delete
                </Button>
              </Box>
            ))}
          </Box>
          <Box textAlign="center">
            {formData.wineItem?.length > 0 ? (
              <Text fontSize="20px" fontWeight="bold">
                Wine Items
              </Text>
            ) : (
              ""
            )}
            {formData.wineItem?.map((item, index) => (
              <Box
                key={index}
                bg="white"
                p={4}
                borderRadius="md"
                display="flex"
                boxShadow="md"
                width="100%"
                mb={1}
                justifyContent="space-evenly"
                alignItems="center"
              >
                <FormLabel>Name</FormLabel>
                <Input width="35%" bg="#E2DFE0" value={item.name} readOnly />
                <FormLabel>Qty</FormLabel>
                <Input
                  width="10%"
                  bg="white"
                  value={item.quantity}
                  onChange={(e) =>
                    handleWineItemChange(index, "quantity", e.target.value)
                  }
                />
                <FormLabel>Price</FormLabel>
                <Input
                  width="12%"
                  bg="white"
                  value={item.price}
                  onChange={(e) =>
                    handleWineItemChange(index, "price", e.target.value)
                  }
                />
                <Button
                  colorScheme="red"
                  onClick={() => handleDeleteItem("wine", index)}
                >
                  Delete
                </Button>
              </Box>
            ))}
          </Box>
          <SimpleGrid columns={2} gap={4} placeItems="left">
            <InputGroup>
              <InputLeftAddon>Name</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="name"
                placeholder="Enter Name"
                value={formData.name}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Phone</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="phoneNo"
                placeholder="Enter Phone"
                value={formData.phoneNo}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>TableNo</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="tableNo"
                placeholder="Enter TableNo"
                value={formData.tableNo}
                readOnly
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>BillNo</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="billNo"
                placeholder="Enter BillNo"
                value={formData.billNo}
                readOnly
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Date</InputLeftAddon>
              <Input
                type="date"
                bg="white"
                onChange={handleInputChange}
                name="createdAt"
                placeholder="Enter Date"
                value={formData.createdAt}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Server</InputLeftAddon>
              <Select
                bg="white"
                onChange={handleInputChange}
                name="server"
                placeholder="Enter Server"
                value={formData.server}
              >
                {serverName?.map((item, index) => (
                  <option key={index} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Taxable</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="totalBilling"
                readOnly
                placeholder="Enter TotalBill"
                value={formData.totalBilling}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Gst</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="tax"
                placeholder="Enter Tax"
                value={formData.tax}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Discount</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="discount"
                placeholder="Enter Discounnt"
                value={formData.discount}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Discount Precentage</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="discountPercentage"
                placeholder="Enter DiscountPercentage"
                value={formData.discountPercentage}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Cash</InputLeftAddon>
              <Input bg="white" name="cash" value={formData.cash} />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Mode</InputLeftAddon>
              <Select
                bg="white"
                onChange={handleInputChange}
                name="mode"
                placeholder="Enter Mode"
                value={formData.mode}
              >
                <option value="Phonepe">Phonepe</option>
                <option value="GooglePe">Googlepe</option>
                <option value="Paytm">Paytm</option>
                <option value="Upi">Upi</option>
                <option value="Card">Card</option>
              </Select>
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Online</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="online"
                placeholder="Enter Online"
                value={formData.online}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Due</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="due"
                placeholder="Enter Online"
                value={formData.due}
              />
            </InputGroup>
          </SimpleGrid>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={4}
            mt={2}
          >
            <Button colorScheme="green" onClick={(e) => handleEdit(e)}>
              Edit
            </Button>
          </Box>
        </ModalBody>

        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditQuickBillModal;
